import { render, staticRenderFns } from "./riskAssessmentCategoryForm.vue?vue&type=template&id=4e8f30b7"
import script from "./riskAssessmentCategoryForm.vue?vue&type=script&lang=js"
export * from "./riskAssessmentCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports